// @flow
import { Clear } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";

type Props = {
	isChecked: boolean
};

const BoolImage = (props: Props) => {
	const { isChecked } = props
	return (
		isChecked ? <CheckIcon color={"success"} fontSize={'small'}/> : <Clear color={"error"} fontSize={'small'}/>
	)
}

export default BoolImage